import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent { }



// WEBPACK FOOTER //
// ./src/app/containers/simple-layout/simple-layout.component.ts